__webpack_require__.p = "/wp-content/themes/auth/shopify-app/connecting/";